import StatusCodes from 'http-status-codes'

import { RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { HttpError } from '@webapp/infrastructure/interfaces/services/IHttpClient'

// Boundary adapter for the detail header models only: they read the
// vendor, user and department repositories of other domains, which throw
// RepoError (vendorRepository.getVendor lets the raw HttpError escape)
// rather than the report module's ReportError. Both error types carry the
// status. Owned repositories classify their own 404s into ReportErrorCode.
export const isNotFoundError = (error: unknown): boolean =>
  (error instanceof RepoError || error instanceof HttpError) &&
  error.status === StatusCodes.NOT_FOUND
